import { Component } from '@theme/component';

const DURATION = 350;
const EASING = 'ease';

export class ProcladFaqItem extends Component {
  requiredRefs = ['details', 'summary', 'wrap'];

  #prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  #animation = null;

  connectedCallback() {
    super.connectedCallback();
    this.refs.summary.addEventListener('click', this.#onSummaryClick);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    this.refs.summary.removeEventListener('click', this.#onSummaryClick);
  }

  #onSummaryClick = (event) => {
    event.preventDefault();

    if (this.refs.details.open) {
      this.#close();
    } else {
      this.#open();
    }
  };

  #open() {
    const { details, wrap } = this.refs;

    this.closest('.proclad-faq__list')
      ?.querySelectorAll('proclad-faq-item')
      .forEach((item) => {
        if (item !== this && item instanceof ProcladFaqItem && item.refs.details.open) {
          item.#close();
        }
      });

    this.#animation?.cancel();

    const startHeight = wrap.getBoundingClientRect().height;
    wrap.style.height = `${startHeight}px`;
    wrap.style.overflow = 'hidden';

    details.setAttribute('open', '');

    if (this.#prefersReducedMotion.matches) {
      wrap.style.height = '';
      wrap.style.overflow = '';
      return;
    }

    wrap.style.height = 'auto';
    const endHeight = wrap.getBoundingClientRect().height;
    wrap.style.height = `${startHeight}px`;

    this.#animation = wrap.animate([{ height: `${startHeight}px` }, { height: `${endHeight}px` }], {
      duration: DURATION,
      easing: EASING,
    });

    this.#animation.finished
      .then(() => {
        wrap.style.height = '';
        wrap.style.overflow = '';
      })
      .catch(() => {});
  }

  #close() {
    const { details, wrap } = this.refs;
    this.#animation?.cancel();

    if (this.#prefersReducedMotion.matches) {
      details.removeAttribute('open');
      return;
    }

    const startHeight = wrap.getBoundingClientRect().height;
    wrap.style.overflow = 'hidden';

    this.#animation = wrap.animate([{ height: `${startHeight}px` }, { height: '0px' }], {
      duration: DURATION,
      easing: EASING,
    });

    this.#animation.finished
      .then(() => {
        details.removeAttribute('open');
        wrap.style.height = '';
        wrap.style.overflow = '';
      })
      .catch(() => {});
  }
}

if (!customElements.get('proclad-faq-item')) {
  customElements.define('proclad-faq-item', ProcladFaqItem);
}

export class ProcladFaqList extends Component {
  connectedCallback() {
    super.connectedCallback();
    this.#viewAllButton?.addEventListener('click', this.#onViewAllClick);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    this.#viewAllButton?.removeEventListener('click', this.#onViewAllClick);
  }

  get #viewAllButton() {
    return this.parentElement?.querySelector('[data-view-all]') ?? null;
  }

  #onViewAllClick = (event) => {
    this.querySelectorAll('proclad-faq-item[hidden]').forEach((item) => {
      item.removeAttribute('hidden');
      item.classList.remove('proclad-faq__item-wrapper--hidden');
    });
    event.currentTarget.remove();
  };
}

if (!customElements.get('proclad-faq-list')) {
  customElements.define('proclad-faq-list', ProcladFaqList);
}
